<template>
  <div>
    <div :id="id" :option="option" class="chartCon" :style="{'height':height}"></div>
  </div>
</template>
<script>
import HighCharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
HighchartsMore(HighCharts);
export default {
  data () {
    return {
    }
  },
  props:['option','id','height'],
  created() {
    // console.log(this.option+this.id);
  },
  methods:{
    getOption(){
		var options=this.option
		    return options;
	  }
  },
  mounted() {
    HighCharts.chart(this.id,this.getOption(this.option));
  },
  updated: function (){
    HighCharts.chart(this.id,this.getOption(this.option));
  }
}
</script>
<style scoped>
.chartCon{
  width:100%;
  margin:0px auto;
  min-height:200px;
}
</style> 
